import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Grid } from '@ha/dsl';
import cx from 'classnames';

import {
  DateInput,
  DatePickerInputsProps,
} from '@ha/marketplace/feature-date-picker';

const useStyles = makeStyles(theme => ({
  inputFromWrapper: {
    marginRight: theme.spacing(2),
  },
  inputWrapper: {
    flexGrow: 1,
  },
}));

const SearchDateRangePickerInputs: React.FC<DatePickerInputsProps> = props => {
  const classes = useStyles();

  const {
    from,
    fromInputProps,
    isFromFocused,
    onFromFocus,
    to,
    toInputProps,
    isToFocused,
    onToFocus,
  } = props;

  return (
    <Grid container justify="space-between" wrap="nowrap">
      <Grid item className={cx(classes.inputWrapper, classes.inputFromWrapper)}>
        <DateInput
          {...fromInputProps}
          dateValue={from}
          onInputClick={onFromFocus}
          focused={isFromFocused}
        />
      </Grid>
      <Grid item className={classes.inputWrapper}>
        <DateInput
          {...toInputProps}
          dateValue={to}
          onInputClick={onToFocus}
          focused={isToFocused}
        />
      </Grid>
    </Grid>
  );
};

export default SearchDateRangePickerInputs;
